import { axiosInstance } from "src/api/axiosInstance";
import type {
  ApiResponse,
  PageContent,
  CommonGroupItem,
  CommonGroupQuery,
  CommonGroupUpsertPayload,
} from "src/types/common/commonCodeTypes";

const BASE = "/v1/admin/common/group";

export const getCommonGroupListApi = async (
  params: CommonGroupQuery
): Promise<ApiResponse<PageContent<CommonGroupItem>>> => {
  const res = await axiosInstance.get<ApiResponse<PageContent<CommonGroupItem>>>(`${BASE}/list`, {
    params: {
      ...params,
      grpCode: params.grpCode?.trim() || undefined,
      grpName: params.grpName?.trim() || undefined,
      useYn: typeof params.useYn === "boolean" ? params.useYn : undefined,
      deleted: typeof params.deleted === "boolean" ? params.deleted : undefined,
      order: params.order || "codeOrder,asc",
    },
  });
  return res.data;
};

// select용: 전체 그룹 가져오기(페이지네이션 없이)
export const getCommonGroupAllApi = async (): Promise<
  ApiResponse<PageContent<CommonGroupItem>>
> => {
  return await getCommonGroupListApi({
    grpCode: undefined,
    grpName: undefined,
    useYn: undefined,
    deleted: false,
    page: 0,
    size: 9999,
    order: "codeOrder,asc",
  });
};

export const createCommonGroupApi = async (
  payload: CommonGroupUpsertPayload
): Promise<ApiResponse<null>> => {
  const res = await axiosInstance.post<ApiResponse<null>>(`${BASE}`, payload);
  return res.data;
};

export const updateCommonGroupApi = async (
  grpCode: string,
  payload: CommonGroupUpsertPayload
): Promise<ApiResponse<null>> => {
  const res = await axiosInstance.put<ApiResponse<null>>(`${BASE}/${grpCode}`, payload);
  return res.data;
};

export const deleteCommonGroupApi = async (grpCode: string): Promise<ApiResponse<null>> => {
  const res = await axiosInstance.delete<ApiResponse<null>>(`${BASE}/${grpCode}`);
  return res.data;
};
